import React from 'react';
import {  withRouter } from 'react-router-dom';
import { Loader } from '../../custom/components/Loader';

const Login = () =>  {

    return (
        <Loader loading={true} />
    );
}

export default withRouter(Login);
